import { SMART_NAME } from "libs/constant/smartForm";
import { get } from "lodash";
import { useSelector } from "react-redux";
import {
  selectCurrentSmartServiceId,
  selectSmartService,
} from "redux/modules/visaForm";

export default function useSmartService() {
  const smartserviceId = useSelector(selectCurrentSmartServiceId);
  const smartService = useSelector(selectSmartService);
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");
  const smartType = SMART_NAME[smartserviceName];

  return { smartserviceId, smartType, smartService };
}
